
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCusAgingGrid extends Serenity.EntityGrid<ReportCusAgingRow, any> {
        protected getColumnsKey() { return ReportCusAgingColumns.columnsKey; }
        protected getDialogType() { return ReportCusAgingDialog; }
        protected getIdProperty() { return ReportCusAgingRow.idProperty; }
        protected getInsertPermission() { return ReportCusAgingRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportCusAgingRow.localTextPrefix; }
        protected getService() { return ReportCusAgingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        public shopid : string;
        // public shopid : string;

        // constructor(container: JQuery) {
        //     super(container);

        //     this.shopid = QRreport.QRywcSpecRow.getLookup().itemById["120"].ShopId ?? null;
        // }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["BrandName"]);
            // groupingMixin.plugin.setDroppedGroups(["PosId"]);

        }
        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            opt.groupingPanel = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();


            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [

                    new Slick.Aggregators.Sum('SumOnHandQty'),
                    new Slick.Aggregators.Sum('SumCostValue'),
                    new Slick.Aggregators.Sum('SumRetailPrice'),
                    new Slick.Aggregators.Sum('P1Qty'),
                    new Slick.Aggregators.Sum('P1CostValue'),
                    new Slick.Aggregators.Sum('P2Qty'),
                    new Slick.Aggregators.Sum('P2CostValue'),
                    new Slick.Aggregators.Sum('P3Qty'),
                    new Slick.Aggregators.Sum('P3CostValue'),
                    new Slick.Aggregators.Sum('P4Qty'),
                    new Slick.Aggregators.Sum('P4CostValue'),
                    new Slick.Aggregators.Sum('P5Qty'),
                    new Slick.Aggregators.Sum('P5CostValue'),
                    new Slick.Aggregators.Sum('HistorySaleAmt')
                ]
            });
           

            return grid;
        }

        // private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
        //     // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
        //     // let columns = Object.keys(options.columnStyles)

            
        //     let descriptions: string[] = [];

        //     if(!Q.isEmptyOrNull(this.shopid)){
        //         descriptions.push("ระบุร้านค้า"+this.shopid)
        //     }else{
        //         descriptions.push("ไม่ระบุร้านค้า")
        //     }
                
           
            
        //     return [descriptions, gridColumns];
        // }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportCusAgingService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            // let reportTitle = 'Sale Report'

            // // Max page width = 277 /// ข้อมูลหน้านี้ไม่พอ
            // let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
            //     0: { field: "Category1", title: "Category1", cellWidth: 16 ,overflow: 'linebreak'},
            //     1: { field: "Category2", title: "Category2", cellWidth: 15, halign: 'center' , overflow: 'linebreak' },
            //     2: { field: "Category3", title: "Category3", cellWidth: 24,overflow: 'linebreak'},
            //     3: { field: "SkuCode", title: "SkuCode", cellWidth: 24 ,overflow: 'linebreak'},
            //     4: { field: "PluCode", title: "PluCode", cellWidth: 24 ,overflow: 'linebreak'},
            //     5: { field: "SkuDesc", title: "SkuDesc", cellWidth: 24 ,overflow: 'linebreak'},
            //     6: { field: "SupplierId", title: "SupplierId", cellWidth: 15, halign: 'center' },
            //     7: { field: "SuplierName", title: "SuplierName", cellWidth: 15, halign: 'center' },
            //     8: { field: "BrandName", title: "BrandName", cellWidth: 25 ,overflow: 'linebreak'},

            //     9: { field: "CostPriceExVat", title: "CostPriceExVat", cellWidth: 20, halign: 'right' },
            //     10: { field: "RetailPrice", title: "RetailPrice", cellWidth: 20, halign: 'right'},
            //     11: { field: "SumOnHandQty", title: "SumOnHandQty", cellWidth: 15, halign: 'right' },
            //     12: { field: "SumCostValue", title: "SumCostValue", cellWidth: 10  },
            //     13: { field: "SumRetailPrice", title: "SumRetailPrice", cellWidth: 15, halign: 'right' },
            //     14: { field: "P1Qty", title: "P1Qty", cellWidth: 15, halign: 'right' },

            //     15: { field: "P1CostValue", title: "P1CostValue", cellWidth: 20, halign: 'right' },
            //     16: { field: "P1TotalToStock", title: "P1TotalToStock", cellWidth: 20, halign: 'right'},
            //     17: { field: "P2Qty", title: "P2Qty", cellWidth: 15, halign: 'right' },
            //     18: { field: "P2CostValue", title: "P2CostValue", cellWidth: 10  },
            //     19: { field: "P2TotalToStock", title: "P2TotalToStock", cellWidth: 15, halign: 'right' },
            //     20: { field: "P3Qty", title: "P3Qty", cellWidth: 15, halign: 'right' },
            //     21: { field: "P3CostValue", title: "P3CostValue", cellWidth: 15, halign: 'right' },
            //     22: { field: "P3TotalToStock", title: "P3TotalToStock", cellWidth: 15, halign: 'right' },
            //     23: { field: "P4Qty", title: "P4Qty", cellWidth: 15, halign: 'right' },
            //     24: { field: "P4CostValue", title: "P4CostValue", cellWidth: 15, halign: 'right' },
            //     25: { field: "P4TotalToStock", title: "P4TotalToStock", cellWidth: 15, halign: 'right' },
            //     26: { field: "P5Qty", title: "P5Qty", cellWidth: 15, halign: 'right' },
            //     27: { field: "P5CostValue", title: "P5CostValue", cellWidth: 15, halign: 'right' },
            //     28: { field: "P5TotalToStock", title: "P5TotalToStock", cellWidth: 15, halign: 'right' },
            //     29: { field: "HistorySaleAmt", title: "HistorySaleAmt", cellWidth: 15, halign: 'right' },
            //     30: { field: "AvgSaleAmt", title: "AvgSaleAmt", cellWidth: 15, halign: 'right' }
            // }

           

           

            // buttons.push(GeniuzPOS.Common.Helpers.Report1311PdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 11,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         // head: ,
            //         headerStyles: {
            //             halign: 'center'
            //         },
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'center'
            //             }
            //         }
            //     }
            // }));

            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpecReportCusAging/edit/123';
                        return false;
                    },
                }
            );
            return buttons;
        }
    }
}